var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 15047",
    fill: "none",
    d: "M0 0h16v16H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.622 7.089L8.91 1.378a1.289 1.289 0 00-1.823 0L1.38 7.085l-.006.006a1.288 1.288 0 00.858 2.2H2.5v4.2A1.51 1.51 0 004.007 15h2.235a.41.41 0 00.41-.41v-3.295a.689.689 0 01.688-.688h1.318a.689.689 0 01.688.688v3.295a.41.41 0 00.41.41h2.234a1.51 1.51 0 001.51-1.508v-4.2h.211a1.289 1.289 0 00.912-2.2zm0 0"
  })));
}
export default SvgHomeIcon;